import IconPassTurn from '@static/images/icon_pass_turn.svg';
import IconTrade from '@static/images/icon_trade.svg';
import { ACTION_BUTTON_IDS } from '../UIGameActionButtonsContainer/utils.ts';
import { ROAD_IMAGE_PATH, SETTLEMENT_IMAGE_PATH, CITY_IMAGE_PATH } from '../../utils/gamePieces.ts';
import CardDevCardBack from '@static/images/card_devcardback.svg';
import IconBeginnerHintInitialPlacement from '@static/images/icon_beginner_hint_initial_placement.svg';
import IconDice from '@static/images/dice_6.svg';
import { GameAction } from '@colonist/game-base-types';
export const BEGINNER_HINT_TYPES = [
    'RollDice',
    'BuyDevCard',
    'Trade',
    'TradeBank',
    'TradePlayers',
    'EndTurn',
    'BuildSettlement',
    'BuildCity',
    'BuildRoad',
    'InitialPlacementCorner'
];
export const GAME_ACTION_TO_BEGINNER_HINT_TYPE = {
    [GameAction.ClickedDice]: 'RollDice',
    [GameAction.BuyDevelopmentCard]: 'BuyDevCard',
    [GameAction.PassedTurn]: 'EndTurn',
    [GameAction.CreateTrade]: 'Trade'
};
// @Dang: Handle the remaining locations when UIGameMap is migrated to React
// TODO: These actions still depend on Pixi.js map: 'BuildSettlement', 'BuildCity', 'BuildRoad', 'InitialPlacementCorner'
export const getBeginnerHintContent = (type, color, resourceName)=>{
    switch(type){
        case 'RollDice':
            return {
                elementId: 'roll-dice-button',
                iconPath: IconDice,
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'rollDice'
                    }
                }
            };
        case 'BuyDevCard':
            return {
                elementId: ACTION_BUTTON_IDS.buyDevCard,
                iconPath: CardDevCardBack,
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'buyDevCard'
                    }
                }
            };
        case 'Trade':
            return {
                elementId: ACTION_BUTTON_IDS.trade,
                iconPath: IconTrade,
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'trade'
                    }
                }
            };
        case 'TradeBank':
            return {
                elementId: ACTION_BUTTON_IDS.tradeBank,
                iconPath: IconTrade,
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'tradeBank',
                        resourceName: resourceName
                    }
                }
            };
        case 'TradePlayers':
            return {
                elementId: ACTION_BUTTON_IDS.tradePlayers,
                iconPath: IconTrade,
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'tradePlayers',
                        resourceName: resourceName
                    }
                }
            };
        case 'EndTurn':
            return {
                elementId: ACTION_BUTTON_IDS.passTurn,
                iconPath: IconPassTurn,
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'endTurn'
                    }
                }
            };
        case 'BuildSettlement':
            return {
                elementId: '',
                iconPath: SETTLEMENT_IMAGE_PATH[color],
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'buildSettlement'
                    }
                }
            };
        case 'BuildCity':
            return {
                elementId: '',
                iconPath: CITY_IMAGE_PATH[color],
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'buildCity'
                    }
                }
            };
        case 'BuildRoad':
            return {
                elementId: '',
                iconPath: ROAD_IMAGE_PATH[color],
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'buildRoad'
                    }
                }
            };
        case 'InitialPlacementCorner':
            return {
                elementId: '',
                iconPath: IconBeginnerHintInitialPlacement,
                description: {
                    key: 'strings:game.beginnerTips.actionHints.description',
                    options: {
                        context: 'initialPlacementCorner'
                    }
                }
            };
        default:
            return undefined;
    }
};
